import React, {useEffect, useReducer, createContext, useState} from 'react'

import {useSearchParams, useParams} from 'react-router-dom'
import { getStrings } from './utilities/lib';

export const DataContext = createContext(null);

const initialData = {
    current: {
        full: null,
        party: null,
        declaration: null,
    },
    prev: {
        full: null, 
        party: null, 
        declaration: null
    },
    results: {
        full: null, 
        party: null, 
        declaration: null
    },
    electionString: '', 
    config: null,
    lang: 'en',
    counter: 0, 
    currentYear: true

}

const DataContextProvider = (props) => {
    const [data, setData] = useState(initialData)
    const {prov, year} = useParams();
    

    let [searchParams, setSearchParams] = useSearchParams();
    let lang = searchParams.get("lang") ? searchParams.get("lang") : "en"

    const STRINGS = getStrings(lang)


    const getStaticData = () => {
        let eYear = year ? year : "2020"
        let eProv = prov ? prov : "nb"

        Promise.all([
            fetch(`data/${eProv}/data/${eYear}/${eProv}_ridingResults.json`)
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('error fetching riding results')
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_partyResults.json`)  //http://electorfederal.blcloud.net/api/party/result/overall/(all)/json
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('error fetching party results')
                    return null

                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_declaration.json`)  // //http://electorfederal.blcloud.net/api/OverallResult/?format=json
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('error fetching declaration results')
                    return null

                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_prevParty.json`)
                .then((res)=> {
                    return res.json();
                })
                .catch(e=>{
                    console.log('previous results do not exist')
                    return null
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_prevDeclaration.json`)
                .then((res)=> {
                    return res.json();
                })
                .catch(e=> {
                    console.log('previous declaration does not exist')
                    return null
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_leaders.json`)
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('Please include party leader data')
                    return null
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_config.json`)  // //http://electorfederal.blcloud.net/api/OverallResult/?format=json
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('Please add election config')
                    return null
                })
            ])
            .then(res=>{
                setData(prevData=>({
                    ...prevData,
                    type: 'SET_INITIAL',
                    current: {
                        full: res[0], 
                        party: res[1],
                        declaration: res[2],    
                    },
                    prev: {
                        party: res[3], 
                        declaration: res[4],     
                    },
                    results: {
                        full: res[0], 
                        party: res[1],
                        declaration: res[2]
                    },
                    leaders: res[5],
                    config: res[6] , 
                    STRINGS: STRINGS, 
                    electionString: `${eProv}_${eYear}`,
                    lang: lang
                }))
            }).catch(e=>{
                console.log('error', e)
            })
    }

    const getDynamicData = () => {

        let eYear = year ? year : "2020"
        let eProv = prov?prov : "nb"

        console.log('fetching data')
        Promise.all([
            fetch(`data/${eProv}/data/${eYear}/${eProv}_ridingResults.json`, {cache:"no-cache"})
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('error fetching riding results')
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_partyResults.json`, {cache:"no-cache"})  //http://electorfederal.blcloud.net/api/party/result/overall/(all)/json
                .then(res=>{
                    return res.json();
                })
                .then(json=>{
                    return json
                })
                .catch(e=>{
                    console.log('error fetching party results')
                }),
            fetch(`data/${eProv}/data/${eYear}/${eProv}_declaration.json`, {cache:"no-cache"})  // //http://electorfederal.blcloud.net/api/OverallResult/?format=json
                .then(res=>{
                    return res.json();
                })
                .catch(e=>{
                    console.log('error fetching declaration results')
                })
            ])
            .then(res=>{
                setData(prevData=>({
                    ...prevData,
                    type: 'SET_INITIAL', 
                    current: {
                        full: res[0], 
                        party: res[1],
                        declaration: res[2]
                    }, 
                    results: prevData.currentYear ? {
                        full: res[0], 
                        party: res[1],
                        declaration: res[2]
                    } : prevData.results
                }))
            }).catch(e=>{
                console.log('error', e)
            })
    }

    useEffect(()=> {
        getStaticData()
    }, [])

    

    useEffect(()=> {
        let interval;
        if (data.config) {
            console.log('updating every ' + (data.config.timer ? data.config.timer : 30000) + 'ms');
            interval = setInterval(()=>{
                getDynamicData();
                
            },(data.config.timer ? data.config.timer : 30000))
        }
        return () => {
            clearInterval(interval)
        }
    }, [data.config])   

    const changeYear = (yearButton) => {
        if (data.currentYear !== yearButton) {
            setData(prevData=>({
                ...prevData,
               currentYear: yearButton, 
               results: prevData[yearButton?'current':'prev']
            }))
        }
    }

    return (
        <DataContext.Provider value={{data, changeYear}}>
            {props.children}
        </DataContext.Provider>
    )
}

export default DataContextProvider